$(document).ready(function() {
	let installPromptEvent;

	window.addEventListener('beforeinstallprompt', (event) => {
		console.debug('beforeinstallprompt event fired');
		// Prevent Chrome <= 67 from automatically showing the prompt
		event.preventDefault();
		// Stash the event so it can be triggered later.
		installPromptEvent = event;
		// Update the install UI to notify the user app can be installed
		if (isMobileDevice()) {
			$('#install-app-wrapper').show(1000);
		}

		document.querySelector('#install-button').addEventListener('click', () => {
			// Update the install UI to remove the install button
			$('#install-app-wrapper').hide();
			// Show the modal add to home screen dialog
			installPromptEvent.prompt();
			// Wait for the user to respond to the prompt
			installPromptEvent.userChoice.then((choice) => {
				if (choice.outcome === 'accepted') {
					console.debug('User accepted the A2HS prompt');
				} else {
					console.debug('User dismissed the A2HS prompt');
				}
				// Clear the saved prompt since it can't be used again
				installPromptEvent = null;
			});
		});

		document.querySelector('#install-close').addEventListener('click', () => {
			// Update the install UI to remove the install button
			console.debug("Ocultamos botón");
			$('#install-app-wrapper').hide();
			// Clear the saved prompt since it can't be used again
			installPromptEvent = null;
		});
	});
});

function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};